import { 
    GET_TICKETS_TYPES_REQUEST,
    GET_TICKETS_TYPES_SUCCESS,
    GET_TICKETS_TYPES_FAILURE,
} from '../actions/ticketsTypes';

const initialState = {
    ticketsTypes:[],
    fetching: false,
    success: false,
};

export default (state = initialState, action) => {
    switch (action.type) {

        case GET_TICKETS_TYPES_REQUEST: {
            return {
                ...state,
                fetching: true,
                success: false,
            };
        }

        case GET_TICKETS_TYPES_SUCCESS: {
            return {
                ...state,
                fetching: false,
                success: true,
                ticketsTypes: action.payload.ticketsTypes,
            };
        }

        case GET_TICKETS_TYPES_FAILURE: {
            return {
                ...state,
                fetching: false,
                success: false,
            };
        }

        default:
            return state;
    }
}